import { useAxios, type UseAxiosOptions } from '@vueuse/integrations/useAxios'
import type { AxiosRequestConfig } from 'axios'
import axiosInstance from '../helpers/axios'

export interface PreparedResponse<T> {
    data: T
    message: string
    success: boolean
}

export interface PaginatedData<T> {
    from: number
    to: number
    total: number
    current_page: number
    last_page: number
    per_page: number
    data: T
}

export type PaginatedPreparedResponse<T> = PreparedResponse<PaginatedData<T>>

export function useApiRequest<T = unknown, D = unknown>(
    url: string,
    config?: AxiosRequestConfig<D>,
    options?: UseAxiosOptions<T>,
) {
    return useAxios<T>(url, config || {}, axiosInstance, options)
}
